import React from "react";
import { textCodes, titleCodes } from "../../template_codes/willow/shipping_page_codes";
import { useTranslate, locales } from "../../translate";

function Shipping() {
    return(
        <div className="container w-4/6 py-10">
            <h1 className="font-semibold text-xl pt-4">{titleCodes.dosmeticTitle.title}</h1>
            <p className="py-1">You can track your order anytime at <a href="https://www.ninjavan.co/en-mm/tracking" className="text-blue-900">https://www.ninjavan.co/en-mm/tracking.</a></p>
            <p className="py-1">{textCodes.domesText2.text}</p>
            <p className="py-1">{textCodes.domesText3.text}</p>
            <p className="py-1">{textCodes.domesText4.text}</p>
            <h1 className="font-semibold text-xl pt-8">{titleCodes.internationalTitle.title}</h1>
            <p className="py-1">{textCodes.interText1.text}</p>
            <h1 className="font-semibold text-xl pt-8">{titleCodes.singaporeTitle.title}</h1>
            <p className="py-1">{textCodes.singText1.text}</p>
            <p className="py-1">You can track your order anytime at <a href="https://www.ninjavan.co/en-sg/tracking" className="text-blue-900">https://www.ninjavan.co/en-sg/tracking</a> once the shipment is received by our Singapore logistics partner. </p>
            <p className="py-1">{textCodes.singText3.text}</p>
            <h1 className="font-semibold text-xl pt-8">{titleCodes.australiaTitle.title}</h1>
            <p className="py-1">{textCodes.ausiText1.text}</p>
            <p className="py-1">{textCodes.ausiText2.text}</p>
            <p className="py-1">You can track your order anytime at <a href="https://www.singpost.com/" className="text-blue-900">https://www.singpost.com/</a> once the shipment is received by our Singapore logistics partner.</p>
            <p className="py-1">{textCodes.ausiText4.text}</p>
            <p className="py-1">{textCodes.ausiText5.text}</p>
        </div>
    );
}

export default Shipping;